import { createMakeStyles } from 'tss-react';
import { useTheme } from '@material-ui/core';

const { makeStyles } = createMakeStyles({ useTheme });

export const useStyles = makeStyles()(() => ({
  ongoingIncidents: {
    height: '100%',

    'div > [class*="MuiCardContent-root"]': {
      padding: '0',
      overflow: 'unset',
    }
  },
}));
